import { createApiClient } from "@shared/api";
import { fetchTransport } from "@shared/api/transports/fetchTransport";

/**
 * Web composition root: the single place the web app runs `createApiClient`,
 * binding the cookie/fetch transport. Consumers import this ready-made
 * singleton (`import { apiClient } from "apiClient"`). Mobile builds its own
 * equivalent from the same `createApiClient` with an axios/Bearer transport.
 */
export const apiClient = createApiClient(fetchTransport);
